export default "__VITE_ASSET__CBMGJ0um__"